import { Box, RadioGroup } from "@outschool/backpack";
import {
  useActivityString,
  useSearchFiltersString
} from "@outschool/ui-components-website";
import React from "react";

import { Filter } from "../Filter";
import { ListingChildFilterProps } from "./ListingFilters";

export default function ClassSizeFilter({
  searchFilters,
  onChange
}: ListingChildFilterProps) {
  const { classSizeOptions } = useActivityString();
  const { getClassSizeFromCapacityFilter, getCapacityFilterFromClassSize } =
    useSearchFiltersString();
  const classSize = getClassSizeFromCapacityFilter(searchFilters);

  const handleFilterChange = (_e: any, selectedValue: string) => {
    const filterValue = getCapacityFilterFromClassSize(selectedValue);
    onChange?.(filterValue);
  };

  return (
    <Filter showTopBorder={false}>
      <Box
        sx={{
          padding: "12px 24px 24px 0px"
        }}
      >
        <RadioGroup
          name="classSize"
          value={classSize}
          options={classSizeOptions}
          onChange={handleFilterChange}
        />
      </Box>
    </Filter>
  );
}
